<template>
<div>
    <v-card class="pa-4 mb-6">
      <h2 class="text-h5 font-weight-bold mb-4">Manage Chalet Price</h2>
      <v-form ref="changePriceForm" v-model="valid" @submit.prevent="ChaletUpdate">
        <v-text-field
          v-model="this.chalet.price"
          label="Change Chalet Price (OMR)"
          :rules="[priceRule]"
          required
          type="number"
          min="0"
          step="1"
          class="mb-4"
        ></v-text-field>
        <v-btn color="primary" :disabled="!valid" @click="ChaletUpdate" class="mb-4">
          Change Price 
        </v-btn>
    </v-form>
    </v-card>
    <v-card class="pa-4 mb-6">
      <h2 class="text-h5 font-weight-bold mb-4">Current Chalet Price: {{ getChaletPrice() }}</h2>
    </v-card>
</div>
</template>
<script>
import apiService from '@/services/apiService.js';
export default {
    name: "PriceChanger",
    props: {
      token: {
        type: String,
        required: true
      }
    },
    data(){
        return {
            chaletPrice: 0,
            addOns: [],
      chalet: {
        price: 0
      },
      valid: false,
        }
    },
    computed: {
    priceRule() {
      return v => (v > 0) || "Price must be greater than 0";
    },
  },
    methods:{
        fetchChaletInfo() {
        this.errorMsg = null;
        apiService.ChaletInfo(this.token)
          .then(res => {
            this.chaletPrice = res.data.price;
          })
          .catch(err => {
            this.$emit('error', err.response?.data?.error || "Failed to fetch confirmed bookings.");
          });
      },
      getChaletPrice(){
        this.fetchChaletInfo()
        return this.chaletPrice;
      },
      ChaletUpdate() {
      if (!this.valid) return;
      const payload = {
        price: parseFloat(this.chalet.price)
      };
      //console.log(this.chalet.price)
      apiService.ChaletUpdate(payload, this.token)
        .then(() => {
          this.getChaletPrice()
          this.$refs.changePriceForm.reset();
        })
        .catch(err => {
          this.$emit('error', err.response?.data?.error || "Failed to add new add-on.");
        });
    },
    }
}
</script>